const PUBLIC_ACCOUNT = 'publicAccount';
const CYCLES = 'cycles';

const CONTRIBUTION_REQUEST = 'contributionRequest';
const CONTRIBUTION_REQUESTS = 'contributionRequests';
const CUSTOM_GOAL_FILTERS = 'customGoalFilters';
const GOAL = 'goal';
const GOAL_OVERVIEW_ORGANIZATION = 'goalOverviewOrganization';
const GOAL_OVERVIEW_TEAM = 'goalOverviewTeam';
const GOAL_OVERVIEW_ME = 'goalOverviewMe';
const USER_ME_TIMELINE = 'userMeTimeline';
const TEAM_TIMELINE = 'teamTimeline';
const TEAM_GOAL_SUMMARY = 'teamGoalSummary';
const GOAL_ALIGNMENTS = 'goalAlignments';
const GOAL_GRAPH = 'goalGraph';
const GOALS_OVERVIEW_FILTER = 'goalsOverviewFilter';
const KPI_TIME_SERIES = 'kpiTimeSeries';
const ORGANIZATION_KPIS = 'organizationKpis';
const ORGANIZATION_TEAMS = 'organizationTeams';
const TEAM_KPIS = 'teamKpis';
const KPI_STATUS_LABELS = 'kpiStatusLabels';
const KPI_PERIOD_TYPES = 'kpiPeriodTypes';

const UPDATE_KPI_PROGRESS_MODAL = 'UpdateKpiProgressModal';
const UPDATE_KPI_PROGRESS_MODAL_KPI = 'kpi';

const TEAMS = 'teams';
const MY_TEAMS = 'myTeams';
const TEAM = 'team';
const SUB_TEAMS = 'subTeams';
const SETTINGS_TEAM = 'settingsTeam';
const SETTINGS_TEAMS = 'settingsTeams';
const SEARCH_TEAMS = 'searchTeams';

const KEY_RESULT = 'keyResult';
const INITIATIVE = 'initiative';

const GQL_INITIATIVE = 'gqlInitiative';
const INITIATIVE_TYPES = 'initiative_types';

const USER = 'user';
const USER_TEAMS = 'userTeams';
const CURRENT_USER_TEAMS = 'currentUserTeams';
const CURRENT_USER_COACHED_TEAMS = 'currentUserCoachedTeams';
const SEARCH_USERS = 'searchUsers';

const GET_RECOMMENDED_ACTIONS = 'getRecommendedActions';
const RELATED_GOALS = 'relatedGoals';

const PROFILE = 'profile';

const LABELS = 'labels';
const SETTINGS_LABELS = 'settingsLabels';
const SETTINGS_INTEGRATIONS_JIRA = 'settingsJiraIntegrations';
const SETTINGS_JIRA_INTEGRATION = 'settingsJiraIntegration';
const SETTINGS_CUSTOM_GOALS_FILTERS = 'settingsCustomGoalFilters';
const JIRA_PROJECTS = 'jiraProjects';
const JIRA_ISSUES = 'jiraIssues';
const JIRA_ISSUE_TYPES = 'jiraIssueTypes';
const SETTINGS_ORG_UNIT_JIRA_PROJECTS = 'settingsOrgUnitJiraProjects';

const GOAL_COLLABORATIONS = 'goalCollaborations';
const COLLABORATORS = 'collaborators';

const TEAM_CAPACITY = 'teamCapacity';
const CAPACITY_ALLOCATION_HUNCHES = 'capacityAllocationHunches';

const CURRENCIES = 'currencies';
const ACCEPT_INVITATION = 'acceptInvitation';
const TEAM_MEMBER_REPORTS = 'teamMemberReports';
const CHECK_IN_TEAM_GOALS = 'checkInTeamGoals';

const KEY_RESULT_REFERENCES = 'keyResultReferences';

const SETTINGS_CYCLE = 'settingsCycle';
const SETTINGS_CYCLES = 'settingsCycles';
const SETTINGS_RHYTHMS = 'settingsRhythms';
const SETTINGS_RHYTHM_CONFIG = 'settingsRhythmConfig';
const ORG_UNIT_CURRENT_CYCLE = 'orgUnitCurrentCycle';
const CYCLES_PHASES = 'cyclesPhases';

const SETTINGS_ACCOUNT = 'settingsAccount';
const ACCOUNT = 'account';

const GOAL_TEMPLATES = 'goalTemplates';
const GOAL_TEMPLATE = 'goalTemplate';

const DRAFTING_GUIDELINES = 'draftingGuidelines';

const SETTINGS_INTEGRATIONS_AZURE = 'settingsAzureIntegrations';
const SETTINGS_INTEGRATIONS_AZURE_DETAILS = 'settingsAzureIntegrationById';
const SETTINGS_INTEGRATIONS_SCIM = 'settingsScimIntegrations';
const SETTINGS_INTEGRATIONS_SAML = 'settingsSamlIntegrations';
const SETTINGS_INTEGRATIONS_MCP = 'settingsMcpIntegrations';
const DOWNLOAD_EXPORT = 'downloadExport';

const SETTINGS_API_CLIENTS = 'settingsApiClients';

const CONVERSATION_STARTERS = 'conversationStarters';
const COMPANION_CONTEXTS = 'companionContexts';
const COMPANION_PROFILE = 'companionProfile';
const COMPANION_THREADS = 'companionThreads';
const COMPANION_THREAD = 'companionThread';
const COMPANION_STARTERS = 'companionStarters';
const NUDGE_SETTINGS = 'nudgeSettings';
const NUDGE_SETTING = 'nudgeSetting';
const CONNECTIONS = 'connections';
const NUDGE_PREVIEW = 'nudgePreview';
const MY_NUDGES = 'myNudges';

const WEBHOOK_SUBSCRIPTIONS = 'webhookSubscriptions';
const WEBHOOK_SUBSCRIPTION = 'webhookSubscription';

const CONVERSATIONS = 'conversations';
const CONVERSATION = 'conversation';

const CONVERSATIONS_NEW = 'conversations_new';
const CONVERSATION_NEW = 'conversation_new';

const SETTINGS_USERS = 'settingsUsers';
const SETTINGS_EXPORT_USERS = 'settingsExportUsers';

const FEED_ENTRIES = 'feedEntries';

const CREATE_TABLEAU_TOKEN = 'createTableauToken';
const TABLEAU_SAMPLE_DATA = 'sampleData';
const TABLEAU_PROD_DATA = 'prodData';

const ALIGNMENT_SEARCH_PARENT_CANDIDATES = 'alignmentSearchParentCandidates';

const PLANNER_PLANS = 'plannerPlans';
const PLANNER_TASKS = 'plannerTasks';

const AZURE_DEVOPS_ORGANIZATIONS = 'azureDevopsOrganizations';
const AZURE_DEVOPS_PROJECTS = 'azureDevopsProjects';
const AZURE_DEVOPS_WORK_ITEMS = 'azureDevopsWorkItems';
const AZURE_DEVOPS_WORK_ITEM_TYPES = 'azureDevopsWorkItemTypes';
const AZURE_DEVOPS_WORK_ITEM_STATES = 'azureDevopsWorkItemStates';

const BUSINESS_UNIT = 'businessUnit';
const BUSINESS_UNITS = 'businessUnits';
const BUSINESS_UNITS_ARCHIVED = 'businessUnitsArchived';
const BUSINESS_UNITS_MEMBERSHIPS = 'businessUnitsMemberships';
const GOAL_OVERVIEW_BUSINESS_UNIT = 'businessUnitGoals';
const BUSINESS_UNIT_KPIS = 'businessUnitKpis';
const BUSINESS_UNIT_ROOT_TEAMS = 'businessUnitRootTeams';

const NAVBAR_ROOT_TEAMS = 'navbarRootTeams';
const NAVBAR_TEAM_SEARCH = 'navbarTeamSearch';

const NOTES = 'notes';

const QUALITY_CHECK_CRITERIA = 'qualityCheckCriteria';
const QUALITY_CHECK_RESULT = 'qualityCheckResult';

const ORG_STRATEGIC_ELEMENTS = 'orgStrategicElements';
const TEAM_STRATEGIC_ELEMENTS = 'teamStrategicElements';
const BUSINESS_UNIT_STRATEGIC_ELEMENTS = 'businessUnitStrategicElements';
const STRATEGIC_ELEMENT_TYPES = 'strategicElementTypes';
const STRATEGIC_ELEMENT = 'gql-strategicElement';
const STRATEGIC_ELEMENT_LINKED_ENTITY_IDS =
  'gql-strategicElementLinkedEntityIds';
const GQL_KPI = 'gql-kpi';
const GQL_KPI_PROGRESS_STATUS = 'gql-kpi-progress-status';
const HAS_GOALS_ORG_PAGE = 'gql-hasGoalsOrgPage';
const HAS_GOALS_BUSINESS_UNIT_PAGE = 'gql-hasGoalsBusinessUnitPage';
const HAS_GOALS_TEAM_PAGE = 'gql-hasGoalsTeamPage';
const INITIATIVE_BY_ID = 'gql-initiativeById';
const GQL_VIEW_INITIATIVE = 'gql-viewInitiative';
const GQL_VIEW_GOAL = 'gql-viewGoal';
const GQL_GOAL_RELATIONS = 'gql-getGoalRelations';
const GQL_KEY_RESULT_RELATIONS = 'gql-getKeyResultRelations';
const GQL_VIEW_KEY_RESULT = 'gql-viewKeyResult';
const GQL_VIEW_STRATEGIC_ELEMENT = 'gql-viewStrategicElement';
const GQL_KEY_RESULT_PARENT_GOAL = 'gql-keyResultParentGoal';
const GQL_ACTIVITY_FEED = 'gql-activityFeed';
const GOAL_ENTITY_LINK_COUNTS = 'gql-goalEntityLinkCounts';

const POWER_BI_WORKSPACES = 'powerBiWorkspaces';
const POWER_BI_REPORTS = 'powerBiReports';
const POWER_BI_EMBED_TOKEN = 'powerBiEmbedToken';

const EXCEL_SHEETS = 'excelSheets';
const EXCEL_COLUMNS = 'excelColumns';

const DASHBOARD = 'dashboard';
const COLLABORATIVE_DOCUMENT_TOKEN = 'collaborativeDocumentToken';

export {
  PUBLIC_ACCOUNT,
  CYCLES,
  CONTRIBUTION_REQUEST,
  CONTRIBUTION_REQUESTS,
  CURRENCIES,
  CUSTOM_GOAL_FILTERS,
  GOAL,
  GOAL_OVERVIEW_ME,
  USER_ME_TIMELINE,
  GOAL_OVERVIEW_ORGANIZATION,
  GOAL_OVERVIEW_TEAM,
  GOAL_ALIGNMENTS,
  GOAL_GRAPH,
  GOAL_COLLABORATIONS,
  GOALS_OVERVIEW_FILTER,
  KPI_TIME_SERIES,
  KPI_PERIOD_TYPES,
  ORGANIZATION_KPIS,
  ORGANIZATION_TEAMS,
  USER,
  USER_TEAMS,
  TEAM_KPIS,
  KPI_STATUS_LABELS,
  UPDATE_KPI_PROGRESS_MODAL,
  UPDATE_KPI_PROGRESS_MODAL_KPI,
  TEAMS,
  MY_TEAMS,
  TEAM,
  SUB_TEAMS,
  GET_RECOMMENDED_ACTIONS,
  RELATED_GOALS,
  KEY_RESULT,
  TEAM_TIMELINE,
  INITIATIVE,
  GQL_INITIATIVE,
  INITIATIVE_TYPES,
  TEAM_GOAL_SUMMARY,
  SEARCH_TEAMS,
  LABELS,
  SETTINGS_LABELS,
  SETTINGS_INTEGRATIONS_JIRA,
  SETTINGS_JIRA_INTEGRATION,
  SETTINGS_CUSTOM_GOALS_FILTERS,
  TEAM_CAPACITY,
  CAPACITY_ALLOCATION_HUNCHES,
  ACCEPT_INVITATION,
  KEY_RESULT_REFERENCES,
  SETTINGS_CYCLE,
  SETTINGS_CYCLES,
  SETTINGS_RHYTHMS,
  SETTINGS_RHYTHM_CONFIG,
  ORG_UNIT_CURRENT_CYCLE,
  CYCLES_PHASES,
  TEAM_MEMBER_REPORTS,
  CHECK_IN_TEAM_GOALS,
  JIRA_PROJECTS,
  JIRA_ISSUES,
  JIRA_ISSUE_TYPES,
  SETTINGS_ORG_UNIT_JIRA_PROJECTS,
  SETTINGS_TEAM,
  SETTINGS_TEAMS,
  COLLABORATORS,
  SETTINGS_ACCOUNT,
  ACCOUNT,
  GOAL_TEMPLATES,
  GOAL_TEMPLATE,
  DRAFTING_GUIDELINES,
  SETTINGS_INTEGRATIONS_AZURE,
  SETTINGS_INTEGRATIONS_AZURE_DETAILS,
  SETTINGS_INTEGRATIONS_SCIM,
  SETTINGS_INTEGRATIONS_SAML,
  SETTINGS_INTEGRATIONS_MCP,
  SETTINGS_API_CLIENTS,
  DOWNLOAD_EXPORT,
  CONVERSATIONS,
  CONVERSATION,
  CONVERSATIONS_NEW,
  CONVERSATION_NEW,
  PROFILE,
  SETTINGS_USERS,
  SETTINGS_EXPORT_USERS,
  FEED_ENTRIES,
  CREATE_TABLEAU_TOKEN,
  TABLEAU_SAMPLE_DATA,
  TABLEAU_PROD_DATA,
  CURRENT_USER_TEAMS,
  CURRENT_USER_COACHED_TEAMS,
  ALIGNMENT_SEARCH_PARENT_CANDIDATES,
  PLANNER_PLANS,
  PLANNER_TASKS,
  AZURE_DEVOPS_ORGANIZATIONS,
  AZURE_DEVOPS_PROJECTS,
  AZURE_DEVOPS_WORK_ITEMS,
  AZURE_DEVOPS_WORK_ITEM_TYPES,
  AZURE_DEVOPS_WORK_ITEM_STATES,
  BUSINESS_UNIT,
  BUSINESS_UNITS,
  BUSINESS_UNITS_ARCHIVED,
  BUSINESS_UNITS_MEMBERSHIPS,
  GOAL_OVERVIEW_BUSINESS_UNIT,
  BUSINESS_UNIT_KPIS,
  BUSINESS_UNIT_ROOT_TEAMS,
  NOTES,
  QUALITY_CHECK_CRITERIA,
  QUALITY_CHECK_RESULT,
  ORG_STRATEGIC_ELEMENTS,
  TEAM_STRATEGIC_ELEMENTS,
  BUSINESS_UNIT_STRATEGIC_ELEMENTS,
  STRATEGIC_ELEMENT,
  STRATEGIC_ELEMENT_TYPES,
  STRATEGIC_ELEMENT_LINKED_ENTITY_IDS,
  GQL_KPI,
  GQL_KPI_PROGRESS_STATUS,
  HAS_GOALS_ORG_PAGE,
  HAS_GOALS_BUSINESS_UNIT_PAGE,
  HAS_GOALS_TEAM_PAGE,
  INITIATIVE_BY_ID,
  GQL_VIEW_INITIATIVE,
  GQL_VIEW_GOAL,
  GQL_GOAL_RELATIONS,
  GQL_KEY_RESULT_RELATIONS,
  GQL_VIEW_KEY_RESULT,
  GQL_VIEW_STRATEGIC_ELEMENT,
  GQL_KEY_RESULT_PARENT_GOAL,
  GQL_ACTIVITY_FEED,
  GOAL_ENTITY_LINK_COUNTS,
  SEARCH_USERS,
  POWER_BI_WORKSPACES,
  POWER_BI_REPORTS,
  POWER_BI_EMBED_TOKEN,
  NAVBAR_ROOT_TEAMS,
  NAVBAR_TEAM_SEARCH,
  EXCEL_SHEETS,
  EXCEL_COLUMNS,
  CONVERSATION_STARTERS,
  COMPANION_CONTEXTS,
  COMPANION_PROFILE,
  COMPANION_THREADS,
  COMPANION_THREAD,
  COMPANION_STARTERS,
  NUDGE_SETTINGS,
  NUDGE_SETTING,
  CONNECTIONS,
  NUDGE_PREVIEW,
  MY_NUDGES,
  DASHBOARD,
  COLLABORATIVE_DOCUMENT_TOKEN,
  WEBHOOK_SUBSCRIPTIONS,
  WEBHOOK_SUBSCRIPTION,
};
